var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"foot-main",style:({background: _vm.isback ? '#fff' : ''})},[_c('cube-button',{domProps:{"textContent":_vm._s(_vm.cacelText)},on:{"click":_vm.handleCacel}}),_c('cube-button',{attrs:{"type":"submit","disabled":_vm.disabled},domProps:{"textContent":_vm._s(_vm.okText)},on:{"click":_vm.handleSure}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }